export default __webpack_public_path__ + "static/media/dvr_bg.ab75579f.png";